<template>
    <Modal id="balance-add" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="title">{{ $t("settings.walletAddBalanceTitle") }}</div>
        <div v-if="isAdmin" class="invoice-details">
            <div class="invoice-title">{{ $t("settings.walletInvoiceDetails") }}</div>
            <div class="invoice-grid">
                <div class="grid-item">
                    <div class="form-label">{{ $t("settings.walletStatusLabel") }}</div>
                    <div class="status-toggle">
                        <div
                            class="status-option"
                            :class="{ active: !invoicePayload.isPaid }"
                            @click="invoicePayload.isPaid = false"
                        >
                            <span class="material-icons">schedule</span>
                            {{ $t("settings.walletUnpaid") }}
                        </div>
                        <div
                            class="status-option"
                            :class="{ active: invoicePayload.isPaid }"
                            @click="invoicePayload.isPaid = true"
                        >
                            <span class="material-icons">check_circle</span>
                            {{ $t("settings.walletPaid") }}
                        </div>
                    </div>
                </div>
                <div class="grid-item" v-show="!invoicePayload.isPaid">
                    <div class="form-label">{{ $t("settings.walletLastPaymentDate") }}</div>
                    <a-date-picker
                        v-model:value="invoicePayload.dueDate"
                        :placeholder="$t('message.dueDate')"
                        class="date-picker"
                    />
                </div>
            </div>
        </div>
        <div class="amount-input">
            <div>{{ $t("settings.ballanceToTransferred") }}</div>
            <a-input class="supsis-input" v-model="price" type="number"></a-input>
        </div>
        <div class="balance-details">
            <div class="detail">
                <div class="detail-title">{{ $t("settings.availableBalance") }}</div>
                <div>{{ formatPrice(wallet.whatsapp.amount) }} {{ $t("billing.currencyTL") }}</div>
            </div>
            <div class="detail">
                <div class="detail-title">{{ $t("settings.balanceReceived") }}</div>
                <div>{{ formatPrice(price) }} {{ $t("billing.currencyTL") }}</div>
            </div>
            <div class="detail">
                <div class="detail-title">{{ $t("settings.totalBalance") }}</div>
                <div>{{ formatPrice(wallet.whatsapp.amount + +price) }} {{ $t("billing.currencyTL") }}</div>
            </div>
        </div>
        <div v-if="isAdmin" class="invoice-option">
            <div class="invoice-option-title">{{ $t("settings.walletInvoiceCreationTitle") }}</div>
            <a-checkbox v-model="invoicePayload.createInvoice">
                {{ $t("settings.walletCreateInvoiceForThisLoad") }}
            </a-checkbox>
        </div>
        <div v-if="!isAdmin">
            <div class="card-title">{{ $t("settings.paymentCard") }}</div>
            <div class="current-card">
                <div class="card-information">
                    <div class="card-type-logo">
                        <DynamicSvg :name="formatedType()" />
                    </div>
                    <div class="card-detail">
                        <div class="card-bin-number">{{ formatedNumber() }}</div>
                        <div class="card-type">{{ billingDetail.cardAssociation }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="balance-footer">
            <div class="supsis-modal-button" @click="cancel">{{ $t("wp.cancel") }}</div>
            <div
                class="supsis-modal-button second"
                :class="{ disabled: isLoading }"
                @click="submit"
            >
                <span v-if="isLoading" class="material-icons loading-icon">refresh</span>
                {{ isLoading ? $t("settings.walletProcessing") : $t("billing.addBalance") }}
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "WalletAddBalance",
    components: {
        Modal,
        DynamicSvg,
    },
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        price: 0,
        isLoading: false,
        invoicePayload: {
            isPaid: false,
            dueDate: moment().add(15, "days").format("YYYY-MM-DD"),
            createInvoice: true, // Varsayılan olarak fatura oluştur
        },
    }),
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
            wallet: (state) => state.wallet.wallet,
        }),
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        formatPrice(price) {
            return (+price).toFixed(2);
        },
        formatedType() {
            if (!this.billingDetail?.cardAssociation) return "";
            return this.billingDetail.cardAssociation[0] + this.billingDetail.cardAssociation.slice(1).toLowerCase();
        },
        submit() {
            if (this.isLoading) return;

            if (this.price <= 0) {
                this.$message.error("Lütfen geçerli bir miktar giriniz.");
                return;
            }

            this.isLoading = true;

            const payload = this.isAdmin
                ? {
                    createInvoice: this.invoicePayload.createInvoice,
                    ...(this.invoicePayload.createInvoice
                        ? {
                            isPaid: this.invoicePayload.isPaid,
                            ...(this.invoicePayload.isPaid ? {} : { dueDate: this.invoicePayload.dueDate }),
                        }
                        : {}),
                }
                : null;

            this.$emit("add-balance", +this.price, payload);
        },
        formatedNumber() {
            if (!this.billingDetail?.binNumber) return "";
            const firstFour = this.billingDetail.binNumber.slice(0, 4);
            const lastFour = this.billingDetail.binNumber.slice(4, 8);
            return `${firstFour} ${lastFour} **** ****`;
        },
    },
};
</script>
<style lang="scss">
#balance-add {
    .title {
        font-size: 24px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 32px;
        text-align: center;
    }

    .invoice-details {
        margin-bottom: 24px;
        padding: 20px;
        background-color: #f4f4fb;
        border-radius: 12px;
        border: 1px solid #d5d6ed;
        box-shadow: 0 2px 8px rgba(70, 73, 157, 0.08);

        .invoice-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
            color: #2c3e50;
        }

        .invoice-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;

            .grid-item {
                .form-label {
                    font-size: 14px;
                    margin-bottom: 10px;
                    color: #546e7a;
                    font-weight: 500;
                }

                .date-picker {
                    width: 100%;
                    border-radius: 8px;
                }

                .status-toggle {
                    display: flex;
                    gap: 12px;
                    width: 100%;

                    .status-option {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        flex: 1;
                        padding: 10px 16px;
                        background-color: #f5f7fa;
                        border-radius: 8px;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        border: 2px solid transparent;
                        font-size: 14px;
                        color: #64748b;
                        font-weight: 500;

                        .material-icons {
                            font-size: 18px;
                        }

                        &.active {
                            background-color: white;
                            border-color: #46499D;

                            &:first-child {
                                color: #ef5350;
                            }

                            &:last-child {
                                color: #4caf50;
                            }
                        }

                        &:hover {
                            background-color: white;
                            transform: translateY(-1px);
                        }
                    }
                }
            }
        }
    }

    .amount-input {
        div {
            margin-bottom: 8px;
            color: #546e7a;
            font-weight: 500;
        }
    }

    .balance-details {
        display: flex;
        align-items: stretch;
        gap: 16px;
        margin: 24px 0;

        .detail {
            background: linear-gradient(135deg, #46499D, #393c84);
            border-radius: 12px;
            padding: 16px 20px;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 8px;
            color: white;
            box-shadow: 0 4px 12px rgba(70, 73, 157, 0.2);
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-2px);
            }

            .detail-title {
                font-size: 13px;
                font-weight: 500;
                text-transform: uppercase;
                opacity: 0.9;
            }

            div:last-child {
                font-size: 18px;
                font-weight: 600;
            }
        }
    }

    .card-title {
        font-size: 18px;
        margin-top: 24px;
        margin-bottom: 16px;
        font-weight: 600;
        color: #2c3e50;
    }

    .current-card {
        background-color: #f8fafc;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 24px;

        .card-information {
            display: flex;
            align-items: center;
            gap: 12px;

            .card-type-logo {
                svg {
                    width: 60px;
                    height: 60px;
                }
            }

            .card-detail {
                .card-bin-number {
                    font-size: 18px;
                    font-weight: 600;
                    color: #2c3e50;
                    margin-bottom: 4px;
                }

                .card-type {
                    font-size: 14px;
                    color: #64748b;
                }
            }
        }
    }

    .supsis-input {
        border-radius: 8px;
        height: auto;
        padding: 12px 20px;
        outline: none !important;
        border: 2px solid #e2e8f0 !important;
        background-color: white;
        transition: all 0.3s ease;
        font-size: 16px;

        &:focus {
            border-color: #46499D !important;
            box-shadow: 0 0 0 3px rgba(70, 73, 157, 0.1);
        }
    }

    .invoice-option {
        margin-top: 24px;
        padding: 16px;
        background-color: #f8fafc;
        border-radius: 8px;
        border: 1px solid #e2e8f0;

        .invoice-option-title {
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 12px;
        }
    }

    .balance-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        margin-top: 24px;
        padding-top: 24px;
        border-top: 1px solid #e2e8f0;
    }

    .supsis-modal-button {
        padding: 10px 24px;
        border-radius: 8px;
        font-weight: 500;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        transition: all 0.3s ease;
        border: 2px solid #e2e8f0;
        background: white;
        color: #64748b;
        display: flex;
        align-items: center;
        gap: 8px;

        &:hover {
            background: #f8fafc;
            border-color: #cbd5e1;
        }

        &.second {
            background: linear-gradient(135deg, #46499D, #393c84);
            color: white;
            border: none;
            box-shadow: 0 4px 12px rgba(70, 73, 157, 0.25);

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 6px 16px rgba(70, 73, 157, 0.35);
            }

            &.disabled {
                opacity: 0.6;
                cursor: not-allowed;
                transform: none;
                box-shadow: 0 4px 12px rgba(70, 73, 157, 0.1);

                &:hover {
                    transform: none;
                    box-shadow: 0 4px 12px rgba(70, 73, 157, 0.1);
                }
            }
        }

        .loading-icon {
            animation: spin 1s linear infinite;
            font-size: 16px;
        }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
}
</style>
